import React from "react";
import "./RegionModeSelector.css";

interface RegionModeSelectorProps {
  regionName: string;
  onSelect: (mode: "trekkings" | "experiences") => void;
}

export default function RegionModeSelector({
  regionName,
  onSelect,
}: RegionModeSelectorProps) {
  return (
    <div className="mode-selector-overlay">
      <div className="mode-selector-modal">
        <div className="mode-selector-header">
          <h2>{regionName}</h2>
          <p className="mode-selector-subtitle">
            Come vuoi esplorare questa regione?
          </p>
        </div>

        <div className="mode-selector-buttons">
          <button
            className="mode-button trails-button"
            onClick={() => onSelect("trekkings")}
          >
            <div className="mode-icon">🥾</div>
            <h3>Percorsi</h3>
            <p>Esplora sentieri e itinerari escursionistici</p>
          </button>

          <button
            className="mode-button activities-button"
            onClick={() => onSelect("experiences")}
          >
            <div className="mode-icon">✨</div>
            <h3>Attività</h3>
            <p>Scopri punti di interesse e attività</p>
          </button>
        </div>

        <div className="mode-selector-footer">
          <small>
            💡 La tua scelta verrà ricordata per le prossime regioni
          </small>
        </div>
      </div>
    </div>
  );
}
